import { datadogRum } from "@datadog/browser-rum";
import Resource from "utils/resourcesUtil";
import {FileFormat} from "./dto/fileFormat";

/**
 * @param {string} documentPath
 * @param purchaseId
 * @return {Promise}
 */
export function getDocument(documentPath, purchaseId) {
  const params = {};
  if(purchaseId){
    params.purchaseId = purchaseId.replaceAll('-','');
  }
  const path = "purchase-service/api/v1/documents" + documentPath;
  return Resource.get(path, { params }).then(response => {
    return response.data;
  }, error => {
    datadogRum.addUserAction('Get document failed', { error, path, options: { params } });
  });
}


export function getPdfStatement( date, isStatementOnly, isSupplementalDoc ) {
  const statementOnlyQueryParam = isStatementOnly ? '&statementOnly=true' : '';
  const supplementalDocQueryParam = isSupplementalDoc ? '&supDocOnly=true' : '';
  const path = `card-bnpl-service/api/v1/customer/statements/files-by-closing-date?date=${date}${statementOnlyQueryParam}${supplementalDocQueryParam}`;
  return Resource.getCard(path,
    {}).then(response => {
    return response.data; //{ {"closingDate": "2020-05-05","content": "string"} }
  }, error => {
    datadogRum.addUserAction('Get HTML Statement Document failed', {error, path, fileDate:date});
  });
}

export function getHtmlStatement(date, format = FileFormat.JPEG) {
  const path = `my-sunbit-service/api/v1/customer/current/card/account/statements/files-by-closing-date?closingDate=${date}&format=${format}`;
  return Resource.getCard(path,
    {}).then((response)=>{
     return response.data;
  }, error => {
    datadogRum.addUserAction('Get HTML Statement Document failed', {error, path, fileDate:date});
  });
}




// WEBPACK FOOTER //
// ./src/services/api/documents.js